import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

// reduxCreator.plugin(resetPlugin);


let redux = reduxCreator.type('FORUMS_LIST_MOVE').plugin(axiosPlugin, {template: "array"});

let fetchForumsListMoveAction = redux.fetchActionGet();

export const TYPES = redux.types;
export const fetchForumsListMove = () => fetchForumsListMoveAction(`/forums/list-forums`);
export const resetForumsListMove = () => redux.actions.reset();

export const forumsListMove = redux.reducer();